document.onreadystatechange = function () {
    if (document.readyState === 'complete') {
        document.querySelector('body').style.cssText = `
            visibility: visible;
            opacity: 1;
        `
    }
}